/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Social_Google_FailedInputs */

const en_auth_social_google_failed = /** @type {(inputs: Auth_Social_Google_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Google sign-in could not be started. Please try again.`)
};

const es_auth_social_google_failed = /** @type {(inputs: Auth_Social_Google_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se pudo iniciar sesion con Google. Intentalo de nuevo.`)
};

/**
* | output |
* | --- |
* | "Google sign-in could not be started. Please try again." |
*
* @param {Auth_Social_Google_FailedInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const auth_social_google_failed = /** @type {((inputs?: Auth_Social_Google_FailedInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Social_Google_FailedInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_auth_social_google_failed(inputs)
	return es_auth_social_google_failed(inputs)
});